import { memo } from "react";
import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";

/**
 * THCA vs THC – Short informational section (120-150 words)
 * Placed before FAQ on homepage for keyword coverage.
 */
export const ThcaVsThcSection = memo(() => {
  return (
    <section className="py-16 md:py-20 bg-background border-t border-border/30">
      <div className="container mx-auto px-4">
        <article className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <FlaskConical className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground m-0">
              THCA vs THC – Vad är skillnaden?
            </h2>
          </div>
          <p className="text-muted-foreground leading-relaxed mb-4">
            THCA (tetrahydrocannabinolsyra) och THC (tetrahydrocannabinol) är två 
            närbesläktade ämnen med en avgörande skillnad. THCA är den naturliga 
            syraformen som förekommer i råa hampaväxter och är icke-psykoaktiv i 
            sin ursprungliga form. THC däremot är den psykoaktiva substansen som 
            uppstår när THCA genomgår dekarboxylering – det vill säga upphettning.
          </p>
          <p className="text-muted-foreground leading-relaxed mb-4">
            I Sverige är THC narkotikaklassat enligt narkotikastrafflagen (1968:64), 
            medan THCA per 2026 inte finns med på Läkemedelsverkets förteckning 
            över kontrollerade substanser. Det innebär att produkter som innehåller 
            THCA, exempelvis{" "}
            <Link to="/kollektioner/thca-vapes" className="text-primary hover:underline">
              THCA vape i Sverige
            </Link>, kan säljas lagligt så länge de uppfyller gällande krav.
          </p>
          <p className="text-sm text-muted-foreground">
            Läs mer i vår{" "}
            <Link to="/blogg/vad-ar-thca" className="text-primary hover:underline">
              kompletta guide om vad THCA är
            </Link>.
          </p>
        </article>
      </div>
    </section>
  );
});

ThcaVsThcSection.displayName = "ThcaVsThcSection";
export default ThcaVsThcSection;
